// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved


import { useRoutes, navigate } from 'hookrouter';
import Routes from './router'
import { useSelector } from 'react-redux'

export default function App() {
  const Authen = useSelector((state: any) => state.Authen)
  // console.log('Authen', Authen);
  if (!Authen.auth && window.location.pathname!=='/') {
    navigate('/login', true);
  }

  const routeResult = useRoutes(Routes)
  return routeResult
}
